import React from 'react'
import { PreOrder } from '../slices/detailOrderSlice';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../hooks';
import { formatPrice } from '../../../utils/formatPrice';

type Props = {
  orderDetails: PreOrder;
  onFetchOrderDetails: () => void;
}
const CustomDetailPreOrder = ({ orderDetails, onFetchOrderDetails }: Props) => {
  const { t } = useTranslation();
  const { direction } = useAppSelector((state) => state.languageSlice)
  return (
    <>
      <Typography
        variant="h6"
        sx={{
          marginBottom: "2%",
          direction: direction === 'ltr' ? 'ltr' : 'rtl'
        }}
      >
        {t("newPreOrder.titles.articles")}
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Libellé Article</TableCell>
              <TableCell>Quantité Commandée</TableCell>
              <TableCell>Unité</TableCell>
              <TableCell>Commentaire</TableCell>
              <TableCell>Prix</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orderDetails.Articles.map((article, index) => (
              <TableRow key={index}>
                <TableCell>{article.LibelleArticle}</TableCell>
                <TableCell>{article.Qte}</TableCell>
                <TableCell>{article.Unite}</TableCell>
                <TableCell>{article.Commentaire ? article.Commentaire : "-"}</TableCell>
                <TableCell>{formatPrice(article.Prix)}</TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Typography
        variant="body1"
        sx={{
          marginTop: "2%",
        }}
      >
        Montant : {formatPrice(orderDetails.Articles.reduce((total, article) => total + Number(article.Qte) * article.Prix, 0))} DH
      </Typography>
    </>
  )
}

export default CustomDetailPreOrder